export default __webpack_public_path__ + "static/apple-touch-icon-eb6b92e8192d3d416880bc8454cf7305.png";